import { render, staticRenderFns } from "./SkuHeader.vue?vue&type=template&id=6ec1dbd7&scoped=true&functional=true"
import script from "./SkuHeader.vue?vue&type=script&lang=js"
export * from "./SkuHeader.vue?vue&type=script&lang=js"
import style0 from "./SkuHeader.vue?vue&type=style&index=0&id=6ec1dbd7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "6ec1dbd7",
  null
  
)

export default component.exports